import { render, staticRenderFns } from "./ConsultationRequest.vue?vue&type=template&id=3aaf0dfd&scoped=true&"
import script from "./ConsultationRequest.vue?vue&type=script&lang=js&"
export * from "./ConsultationRequest.vue?vue&type=script&lang=js&"
import style0 from "./ConsultationRequest.vue?vue&type=style&index=0&id=3aaf0dfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaf0dfd",
  null
  
)

export default component.exports